export default __webpack_public_path__ + "static/0246-2f7a4516aeb2bdb013c75230e877bcdc.png";